import { useEffect, useState } from "react";

export default function Countdown({ target }) {
  const [t, setT] = useState(() => diff(target));
  useEffect(() => {
    const id = setInterval(() => setT(diff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);
  const cells = [
    { l: "D", v: t.d }, { l: "H", v: t.h }, { l: "M", v: t.m }, { l: "S", v: t.s },
  ];
  return (
    <div className="flex items-center gap-2">
      {cells.map((c, i) => (
        <div key={i} className="min-w-[54px] px-2 py-2 rounded-md glass text-center">
          <div className="font-hero text-2xl leading-none text-[#FFBF00]">{String(c.v).padStart(2, "0")}</div>
          <div className="text-[9px] uppercase tracking-widest text-white/50 mt-1">{c.l}</div>
        </div>
      ))}
    </div>
  );
}

function diff(iso) {
  const now = Date.now();
  const t = new Date(iso).getTime();
  const s = Math.max(0, Math.floor((t - now) / 1000));
  return {
    d: Math.floor(s / 86400),
    h: Math.floor((s % 86400) / 3600),
    m: Math.floor((s % 3600) / 60),
    s: s % 60,
  };
}
